import { childSupport } from '../../../../strings/titles'
import { formatReviewString, formatPersonName } from '../../../../utilities'
import { dateToString } from '../../../../utilities/methods/dateToString'
import { Inspect } from '../../../../components/Inspect'

export const InspectFCS = ({ goBackToPage, pages, values }) => {
  const {
    amount_owed,
    children,
    owe_more_than_minimum_yn,
    subject_in_different_location_yn,
    subject_location,
    court_name,
    court_order_exists_yn,
    case_number,
    court_order_date,
    case_worker_assigned_yn,
    case_worker_first_name,
    case_worker_last_name,
    case_worker_middle_name,
    case_worker_suffix,
    case_worker_phone,
    case_worker_email
  } = values
  const sep = ', '

  const allegationDetails = [
    {
      heading: 'Allegation type',
      field_name: 'allegation',
      value: childSupport,
      omitEdit: true
    },
    {
      heading: 'Does this person currently owe more than $5,000?',
      field_name: 'owe_more_than_minimum_yn',
      value: amount_owed
        ? owe_more_than_minimum_yn + sep + amount_owed
        : owe_more_than_minimum_yn
    },
    {
      heading:
        'Does this person reside in a different state/country than the child?',
      field_name: 'subject_in_different_location_yn',
      value: subject_location
        ? subject_in_different_location_yn + sep + subject_location
        : subject_in_different_location_yn
    },
    {
      heading: 'Is there a valid court order?',
      field_name: 'court_order_exists_yn',
      value: court_name
        ? court_order_exists_yn + sep + court_name + sep + case_number
        : court_order_exists_yn
    }
  ]
  if (court_order_exists_yn.toLowerCase() === 'yes') {
    allegationDetails.push({
      heading: 'Date of first court order',
      field_name: 'court_order_date',
      value: formatReviewString(
        court_order_date &&
          court_order_date.yearValue &&
          dateToString(court_order_date)
      )
    })
  }
  allegationDetails.push({
    heading: 'Is there an assigned state/local/tribal case worker?',
    field_name: 'case_worker_assigned_yn',
    value: case_worker_assigned_yn
  })
  if (case_worker_assigned_yn.toLowerCase() === 'yes') {
    allegationDetails.push(
      {
        heading: 'Case worker full name',
        field_name: 'case_worker_first_name',
        value: formatReviewString(
          formatPersonName(
            case_worker_first_name,
            case_worker_middle_name,
            case_worker_last_name,
            case_worker_suffix
          )
        )
      },
      {
        heading: 'Case worker phone',
        field_name: 'case_worker_phone',
        value: formatReviewString(case_worker_phone)
      },
      {
        heading: 'Case worker email',
        field_name: 'case_worker_email',
        value: formatReviewString(case_worker_email)
      }
    )
  }

  const childDetails =
    children &&
    children.map((child, index) => ({
      heading: `Child ${index + 1}`,
      field_name: 'children',
      value: child.age
    }))
  return Inspect({
    goBackToPage,
    pages,
    values,
    allegationDetails,
    childDetails
  })
}
